"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContentTypesMapping = exports.getContentTypes = exports.SORT_OPTIONS = exports.LEGACY_CONTENT_TYPES = exports.CONTENT_TYPES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _common = require("@insided/shared/utils/common");

var _CONTENT_TYPES;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CONTENT_TYPE_QUESTION = 'question';
var CONTENT_TYPE_CONVERSATION = 'conversation';
var CONTENT_TYPE_ARTICLE = 'article';
var CONTENT_TYPE_IDEA = 'idea';
var CONTENT_TYPE_PRODUCT_UPDATE = 'productUpdate';
var CONTENT_TYPE_ALL = 'all';
var CONTENT_TYPES = (_CONTENT_TYPES = {}, (0, _defineProperty2.default)(_CONTENT_TYPES, CONTENT_TYPE_QUESTION, 'Questions'), (0, _defineProperty2.default)(_CONTENT_TYPES, CONTENT_TYPE_CONVERSATION, 'Conversations'), (0, _defineProperty2.default)(_CONTENT_TYPES, CONTENT_TYPE_ARTICLE, 'Articles'), (0, _defineProperty2.default)(_CONTENT_TYPES, CONTENT_TYPE_IDEA, 'Ideas'), (0, _defineProperty2.default)(_CONTENT_TYPES, CONTENT_TYPE_PRODUCT_UPDATE, 'Product Updates'), _CONTENT_TYPES);
exports.CONTENT_TYPES = CONTENT_TYPES;

var getConversationLabel = function getConversationLabel() {
  var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

  return isBugContentTypeEnabled ? 'Bugs' : 'Conversations';
};

var getContentTypes = function getContentTypes() {
  var _ref;

  return _ref = {}, (0, _defineProperty2.default)(_ref, CONTENT_TYPE_QUESTION, 'Questions'), (0, _defineProperty2.default)(_ref, CONTENT_TYPE_CONVERSATION, getConversationLabel()), (0, _defineProperty2.default)(_ref, CONTENT_TYPE_ARTICLE, 'Articles'), (0, _defineProperty2.default)(_ref, CONTENT_TYPE_IDEA, 'Ideas'), (0, _defineProperty2.default)(_ref, CONTENT_TYPE_PRODUCT_UPDATE, 'Product Updates'), _ref;
};

exports.getContentTypes = getContentTypes;

var getContentTypesMapping = function getContentTypesMapping() {
  return [{
    id: CONTENT_TYPE_QUESTION,
    title: 'Questions',
    children: []
  }, {
    id: CONTENT_TYPE_CONVERSATION,
    title: getConversationLabel(),
    children: []
  }, {
    id: CONTENT_TYPE_ARTICLE,
    title: 'Articles',
    children: []
  }, {
    id: CONTENT_TYPE_IDEA,
    title: 'Ideas',
    children: []
  }, {
    id: CONTENT_TYPE_PRODUCT_UPDATE,
    title: 'Product Updates',
    children: []
  }];
};

exports.getContentTypesMapping = getContentTypesMapping;

var LEGACY_CONTENT_TYPES = _objectSpread(_objectSpread({}, CONTENT_TYPES), {}, (0, _defineProperty2.default)({}, CONTENT_TYPE_ALL, 'All content types'));

exports.LEGACY_CONTENT_TYPES = LEGACY_CONTENT_TYPES;
var SORT_OPTIONS = {
  views: 'Number of views',
  lastActivityAt: 'Last activity',
  replyCount: 'Reply count',
  publishedAt: 'Publication date'
};
exports.SORT_OPTIONS = SORT_OPTIONS;